<p-panel header="UIU - Immobile Selezionato">
    <div fxLayout="row wrap">
        <p-table 
            #imsel 
            [columns]="lpColumns" 
            [value]="imTableData" 
            [scrollable]="true" 
            scrollHeight="300px">
            <ng-template pTemplate="body" let-rowData>
                <tr>
                    <td style="font-weight: bold;">{{rowData.label}}</td>
                    <td>{{rowData.value}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-panel>
<p-panel header="Lista Planimetrie" [style]="{'margin-top':'0.2rem'}">
    <div fxLayout="row wrap">
        <p-table 
            #lpsel 
            [columns]="lpColumns" 
            [value]="lpTableData" 
            [scrollable]="true" 
            [scrollHeight]="scrollHeight"
            (onRowSelect)="onSelectFloorplan($event)"
            (onRowUnselect)="onUnselectFloorplan($event)"
            [(selection)]="selectedFloorPlan"
            selectionMode="single">
            <ng-template pTemplate="body" let-rowData>
                <tr [pSelectableRow]="rowData">
                    <td style="text-align: center; padding: 0.5rem !important; user-select: none;">{{rowData.nome}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-panel>
<p-panel header="Dati Testata" [style]="{'margin-top':'0.2rem'}">
    <div *ngIf="jsonLoaded" fxLayout="row wrap">
        <p-table 
            #lpsel 
            [columns]="lpColumns" 
            [value]="dtTableData" 
            [scrollable]="true" 
            scrollHeight="250px">
            <ng-template pTemplate="body" let-rowData>
                <tr *ngIf="rowData.label !== 'Errore'">
                    <td style="font-weight: bold;">{{rowData.label}}</td>
                    <td>{{rowData.value}}</td>
                </tr>
                <tr *ngIf="rowData.label === 'Errore'">
                    <td style="font-weight: bold; color: red">{{rowData.label}}</td>
                    <td style="color: red">{{rowData.value}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div *ngIf="!jsonLoaded" class="spinner-sm" style="margin-top: 2rem;">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>
</p-panel>


